const axios = require('axios');

module.exports.queryDatosGestion = function queryDatosGestion(endpoint, json) {
  axios.post(endpoint, json)
    .then((response) => {
    });
};

/**
 * Funcion que construye el data set para el modulo de graficos
 * @param {*} indicadores respuesta enpoint
 * @param {*} datacollectionMod estructura de dataCollection para grafico de datos
 */
module.exports.contruyeDataCollection = function contruyeDataCollection(indicadores, datacollectionMod, valorPrueba) {
  const labels = []; // Almacena los labels de los graficos
  const keys = []; // Almacena el key de cada programa, con este se haran las consultas al servidor
  const series = []; // Almacena el nombre de las series para cada grafico (ej, Gestionados, No gestionados, Total)
  const filtros = []; // Agrega los filtros para cada serie (ej, gestionados, no_gestionados, total)
  const matrizDatos = [[]];
  const data = indicadores.modulo_data; // Almacena la informacion que se va a pintar como graficos
  // this.initDataCollections()
  const base = [255, 255, 255];
  let vectorColores = [];

  datacollectionMod.modulo = indicadores.modulo; // Puede ser gestion, formularios, encuentros, facturacion, etc

  datacollectionMod.titulo_grafico = indicadores.titulo_grafico;

  datacollectionMod.key_grafico = indicadores.key_grafico;

  data.map((programas, index) => {
        
        let key_programa = programas.key // Obtiene el key de cada programa

        let labels_programa = programas.nombre

        keys.push(key_programa)

        labels.push(labels_programa) 

        let programa = programas.data   // Se obtienen los datos de cada programa
                  
        programa.map(function(jsonValores, index1){
            if(matrizDatos[index1] == undefined){
                matrizDatos[index1] = []
            }
            series.push(jsonValores.nombre)
            filtros.push(jsonValores.filtro)
            matrizDatos[index1].push(jsonValores.valor) // Matriz datos va a almacenar los valores de cada programa (pos0: valorRegistrado RHB, pos1: valorRegistrado tab ...)
        })
    });

  datacollectionMod.datasets = [];

  datacollectionMod.backgroundColor = [];

  matrizDatos.map((datos, index2) => {
        datacollectionMod["datasets"].push({
            data : matrizDatos[index2],
            name : series[index2],
            filtro : filtros[index2]
        })
        vectorColores.push("rgb(" + (base[0]-index2*40) + "," + (base[1]-index2*40) + "," + (base[2]-index2*40) + ")")
    });

  datacollectionMod.labels = labels;
  datacollectionMod.keys = keys;
  vectorColores = vectorColores.reverse();
  vectorColores[vectorColores.length - 1] = 'rgba(0,0,0,0)';
  datacollectionMod.backgroundColor = vectorColores;

  return datacollectionMod;

};



// WEBPACK FOOTER //
// ./src/js/graficos.js